import React, { useState } from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { FlaskConical, RadioTower } from "lucide-react";
import { getRememberMode, TRADING_MODES } from "@/lib/tradingMode";

const modeCards = [
  {
    mode: TRADING_MODES.BACKTESTING,
    icon: FlaskConical,
    title: "Backtesting",
    description: "Simula strategie su dati storici senza inviare ordini reali.",
    buttonLabel: "Apri Backtesting",
    className: "from-primary/20 to-primary/5 border-primary/30",
  },
  {
    mode: TRADING_MODES.LIVE,
    icon: RadioTower,
    title: "Live Trading",
    description: "Opera sui mercati reali con ordini effettivi.",
    buttonLabel: "Apri Live Trading",
    className: "from-destructive/20 to-destructive/5 border-destructive/40",
  },
];

export default function ModeSelectionPage({ onSelectMode }) {
  const [rememberChoice, setRememberChoice] = useState(getRememberMode());

  return (
    <div className="relative flex min-h-screen items-center justify-center overflow-hidden bg-background p-4">
      <div className="absolute inset-0 bg-gradient-to-br from-primary/10 via-background to-destructive/10" />
      <div className="absolute -left-16 top-20 h-64 w-64 rounded-full bg-primary/20 blur-3xl" />
      <div className="absolute -right-20 bottom-16 h-80 w-80 rounded-full bg-destructive/20 blur-3xl" />

      <Card className="relative z-10 w-full max-w-4xl border-2 border-border/60 bg-card/95 shadow-2xl backdrop-blur-md" data-testid="mode-selection-card">
        <CardHeader className="space-y-2 text-center">
          <CardTitle className="text-3xl font-bold tracking-tight">Scegli modalita di lavoro</CardTitle>
          <CardDescription className="text-base">
            Puoi cambiare modalita in qualsiasi momento dal pulsante rapido.
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-6">
          <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
            {modeCards.map((item) => {
              const Icon = item.icon;
              return (
                <Card
                  key={item.mode}
                  className={`border bg-gradient-to-br ${item.className} shadow-lg transition-all hover:scale-[1.01]`}
                >
                  <CardHeader className="space-y-3">
                    <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-background/80">
                      <Icon className="h-6 w-6" />
                    </div>
                    <CardTitle>{item.title}</CardTitle>
                    <CardDescription className="min-h-[48px] text-foreground/80">
                      {item.description}
                    </CardDescription>
                  </CardHeader>
                  <CardContent>
                    <Button
                      className="w-full rounded-full"
                      onClick={() => onSelectMode(item.mode, rememberChoice)}
                      data-testid={`select-mode-${item.mode}`}
                    >
                      {item.buttonLabel}
                    </Button>
                  </CardContent>
                </Card>
              );
            })}
          </div>

          <div className="flex items-center justify-center gap-3 rounded-xl border border-border bg-secondary/50 px-4 py-3">
            <Switch
              id="remember-mode"
              checked={rememberChoice}
              onCheckedChange={setRememberChoice}
              data-testid="remember-mode-switch"
            />
            <Label htmlFor="remember-mode" className="cursor-pointer text-sm font-medium">
              Ricorda la mia scelta su questo dispositivo
            </Label>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
